import { render } from "./multipleResponses.vue?vue&type=template&id=e6c390b0"
import script from "./multipleResponses.vue?vue&type=script&lang=js"
export * from "./multipleResponses.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__